import { render, staticRenderFns } from "./RemoveMemberModal.vue?vue&type=template&id=c1d70e46&scoped=true&"
import script from "./RemoveMemberModal.vue?vue&type=script&lang=js&"
export * from "./RemoveMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d70e46",
  null
  
)

export default component.exports